// Key industrial-project lease annual rent (重点产业项目租赁用地年租金).
//
// Per rules/RULES_INDUSTRIAL.md §5 and logic/CALCULATION_INDUSTRIAL.md §5:
//
//   年租金底价 = 20年期地价 × 3%
//
// The 20-year land price is the standard new-supply calculation
// applied with `landTermYears = 20` for every item. Industry
// orientation / industry project-type factors are already wired into
// the new-supply engine (RULES_INDUSTRIAL.md §2/§3) and so apply
// automatically; per §2/§3 rule 1, supporting commercial
// (配套商业) is excluded from those industry discounts — its factor
// stays at 1.

import type { CalculationResult } from "./calculation-result.js";
import type { BuildingItem } from "./building-item.js";
import type { MarketPriceSet } from "./market-price.js";
import type { Parcel } from "./parcel.js";

/** Lease horizon in years — hard-coded per RULES_INDUSTRIAL.md §5. */
export const KEY_INDUSTRIAL_LEASE_TERM_YEARS = 20;

/** Annual-rent ratio (3%) per RULES_INDUSTRIAL.md §5. */
export const KEY_INDUSTRIAL_LEASE_ANNUAL_RATIO = 0.03;

export interface KeyIndustrialLeaseAnnualRentInput {
  readonly parcel: Parcel;
  readonly prices: MarketPriceSet;
  readonly items: BuildingItem[];
}

export interface KeyIndustrialLeaseAnnualRentResult {
  /** The new-supply-style calculation result run with a 20-year term. */
  readonly baseResult: CalculationResult;
  /** Sum of all items' land prices under the 20-year term. */
  readonly twentyYearLandPrice: number;
  /** `twentyYearLandPrice × 3%` — the annual rent. */
  readonly annualRent: number;
  /** Convenience accessor for `baseResult.validationMessages`. */
  readonly validationMessages: CalculationResult["validationMessages"];
  /** Note: 配套商业 items are at full price (no industry discount). */
  readonly note?: string;
}